export enum enumFicaStatusOnOpening {
  New=1,
  Accepted,
  Rejected,
  Expired,
  Closed
}

export namespace enumFicaStatusOnOpening {
  export function values() {
    return Object.keys(enumFicaStatusOnOpening).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

